import { ConfiguredCarPackageFeatureFragment } from '~/graphql/__generated__/graphql';
import { CatalogItemType, FeatureOrPackage } from '~/graphql/types';
import GetUrlFromImageSet from '~/graphql/utils/get-from-image-set';

export const showMoreInformationDialog = (item: FeatureOrPackage | ConfiguredCarPackageFeatureFragment) => {
	// Determines if the more information dialog should be shown or not for a package/feature
	// TODO add video when available
	const { texts } = item;
	const tyreLabels = item.__typename === 'ConfiguredCarFeature' ? item.tyreLabels : undefined;

	const defaultInfo = {
		imageUrl:
			item.__typename === 'ConfiguredCarPackageFeature'
				? item?.images?.smallImageHD?.url || item?.images?.outerTileHD?.url
				: GetUrlFromImageSet(item?.imageSets, 'small_hd_image') ||
					GetUrlFromImageSet(item?.imageSets, 'outer_tile_hd'),
		introText: texts?.intro,
		description: texts?.akText,
		remarks: texts?.akRemarks,
		tyreLabels: (tyreLabels || []).filter((label) => !!label?.tyreLabelUrl).length > 0,
	};

	if (item.__typename === 'ConfiguredCarPackage') {
		if (item.featureGroup === 'RIMS') {
			defaultInfo.imageUrl = GetUrlFromImageSet(item.imageSets, 'wheel_image');
		}
		if (item.featureGroup === 'INTERIOR_TILES') {
			defaultInfo.imageUrl = GetUrlFromImageSet(item.imageSets, 'interior_tile_hd_square');
			defaultInfo.description = item?.content?.at(0)?.texts?.akText;
		}
	}
	return !!(
		defaultInfo.imageUrl ||
		defaultInfo.introText ||
		defaultInfo.description ||
		defaultInfo.remarks ||
		defaultInfo.tyreLabels
	);
};

export const showTrimlineMoreInformationDialog = (trimline: CatalogItemType['trimline']) => {
	// Determines if the more information dialog should be shown or not for a trimline

	const imageUrls = trimline.__item.images.filter((img) => img.width > 680 && img.width < 800).map((itm) => itm.url);
	const imageUrl = imageUrls[0] || trimline.__item.images[11]?.url;
	const description = trimline.__item.description?.trim();
	const remarks = trimline.__item.remarks;

	return !!(imageUrl || description || remarks);
};
